module.exports = __webpack_public_path__ + "img/popularize-icon3-05.5db32d38.png";